export const HOME_AUTH_LOGIN_ROUTE = '/login';
// Token-based auto-login (integrations, registration, SN forward). Kept off
// /login so analytics only see /login when a member logs in from the login page
export const AUTO_LOGIN_ROUTE = '/auth/continue';
export const ONBOARDING_BASE_ROUTE = '/onboarding';
export const ONBOARDING_AUTH_LOGIN_ROUTE = `${ONBOARDING_BASE_ROUTE}/login`;
export const HOME_DEPOT_SETUP_OR_SKIP_ROUTE = '/onboarding/setuphomedepot';
export const HOME_DEPOT_SETUP_WEB = '/onboarding/setuphomedepot/web';
export const SAVED_ROUTE = '/saved';
export const HOME_ROUTE = '/home';
export const RESOURCES_ROUTE = '/resources';
export const REWARDS_ROUTE = '/rewards';
export const WALLET_ROUTE = '/wallet';
export const COACH_ROUTE = '/coaching';
export const TRAINING_ROUTE = '/training';
export const DESIGN_SERVICES_ROUTE = '/designservices';
export const ADVISORY_BOARDS_ROUTE = '/advisoryboards';
export const MYACCOUNT_ROUTE = '/myaccount';
export const SOLUTION_ROUTE = '/solution';
export const MYACCOUNT_SETTINGS_ROUTE = `${MYACCOUNT_ROUTE}/settings`;
export const MYACCOUNT_MEMBERSHIPS_ROUTE = `${MYACCOUNT_ROUTE}/memberships`;
export const MYACCOUNT_PREFERENCES_ROUTE = `${MYACCOUNT_ROUTE}/preferences`;
export const MYACCOUNT_SOLUTION_ROUTE = `${MYACCOUNT_ROUTE}${SOLUTION_ROUTE}`;
export const MYACCOUNT_FAQ_ROUTE = `${MYACCOUNT_ROUTE}/faqs`;
export const MYACCOUNT_CONTACT_US_ROUTE = `${MYACCOUNT_ROUTE}/contact`;
export const SEARCH_ROUTE = '/search';
export const MORE_ROUTE = '/morecontent';
// partner routes
export const PARTNERS_ROUTE = '/partners';
export const PARTNERS_ROUTE_HOME_DEPOT = `${PARTNERS_ROUTE}/homedepot`;
export const PARTNERS_ROUTE_HD_SUPPLY = `${PARTNERS_ROUTE}/hdsupply`;
export const PARTNERS_ROUTE_CAPITAL_WRAPS = `${PARTNERS_ROUTE}/capitalwraps`;
export const PARTNERS_ROUTE_SPARTAN_TOOL = `${PARTNERS_ROUTE}/spartantool`;
export const PARTNERS_ROUTE_WINSUPPLY = `${PARTNERS_ROUTE}/winsupply`;
export const PARTNERS_ROUTE_WESUPPLYTRADES = `${PARTNERS_ROUTE}/wesupplytrades`;
export const PARTNERS_ROUTE_SUNBELT_RENTALS = `${PARTNERS_ROUTE}/sunbeltrentals`;
export const PARTNERS_ROUTE_COAST = `${PARTNERS_ROUTE}/coast`;
export const PARTNERS_ROUTE_EVERCONNECT = `${PARTNERS_ROUTE}/everconnect`;
export const PARTNERS_ROUTE_RINNAI = `${PARTNERS_ROUTE}/rinnai`;
export const PARTNERS_ROUTE_POSTCARDMANIA = `${PARTNERS_ROUTE}/postcardmania`;

export const isOnboarding = () => window?.location?.pathname?.includes(ONBOARDING_BASE_ROUTE);
